<template>
  <div v-if="!this.$store.state.loadingChartData" :loading="this.$store.state.loadingChartData">
    <canvas id="economicChart" style="max-height: 35rem" :loading="this.$store.state.loadingChartData"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "economic-chart",
  props: {
    chartType: String,
    chartData: Object,
    chartOptions: Object,
  },
  components: {
    Chart,
  },
  data() {
    return {
      responsive: true,
      sidebarStore: false,
      options: {
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "GDP Per Capita ($)",
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Year",
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        hoverOffset: 4,
      },
    };
  },
  mounted() {
    let { chartType, chartData, chartOptions } = this;
    this.chartConstructor(chartType, chartData, chartOptions);
  },
  methods: {
    chartConstructor(chartType, chartData, chartOptions) {
      const chartElement = document.getElementById("economicChart");
      const chart = new Chart(chartElement, {
        type: "line",
        data: chartData,
        options: this.options,
      });
    },
  },
};
</script>
